// import React from "react";
// import Editor from "react-simple-wysiwyg";

// const CommonTextEditor = ({ onChange, value, name }) => {
//   return <Editor value={value} onChange={onChange} name={name} style={{ maxHeight:"500px", overflowY: "scroll"}}/>;
// };

// export default CommonTextEditor;


import React from "react";
import Editor from "react-simple-wysiwyg";

const CommonTextEditor = ({
  onChange,
  value,
  name,
  businessListDisable = false,
  isReadOnly = false,
  onFocus,
}) => {
  const isDisabled = businessListDisable || isReadOnly;

  const handleChange = (e) => {
    if (!isDisabled && onChange) {
      onChange(e);
    }
  };

  const handleFocus = () => {
    if (!isDisabled && onFocus) {
      onFocus();
    }
  };

  return (
    <Editor
      className="common-text-editor"
      value={value || ""}
      onChange={handleChange}
      name={name}
      style={{
        backgroundColor: isDisabled ? "#f5f5f5" : "white",
        cursor: isDisabled ? "not-allowed" : "text",
      }}
      disabled={isDisabled}
      onFocus={handleFocus}
    />
  );
};

export default CommonTextEditor;

